import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from './..'
import { Pmi } from '../../types/pmi'
import * as Sentry from '@sentry/browser'
import { Ampli } from '@homebot/shared-util-quartermaster/types'
import { MORTGAGE_INSURANCE_TOPIC_KEY } from '../../constants/topicKeys'
import { createHomeownerMessage } from '../../api/mikasa/requests'
import { selectHomeId } from '../selectors/home/refinance'
import { selectClientId } from '../selectors/client'
import { IDLE, FAILED, PENDING, SUCCEEDED } from '../../types/loadingStatus'
export interface DMRequestParamTypes {
  message: string
  topic: string
  ampli: Ampli | undefined
}

export const sendPmiRemovalDMRequest = createAsyncThunk(
  'sendPmiRemovalDMRequest',
  async ({ message, topic, ampli }: DMRequestParamTypes, thunkApi) => {
    const state = thunkApi.getState() as RootState
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const homeId = selectHomeId(state)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const clientId = selectClientId(state)

    try {
      const options = {
        topic,
        topicKey: MORTGAGE_INSURANCE_TOPIC_KEY,
        message,
        clientId,
      }

      await createHomeownerMessage(homeId, options, ampli)
    } catch (error) {
      Sentry.captureException(error)
    }
  }
)

const initialState: Pmi = {
  pmiDMRequestedStatus: IDLE,
}

const pmiSlice = createSlice({
  name: 'Pmi',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(sendPmiRemovalDMRequest.pending, state => {
        if (state.pmiDMRequestedStatus === IDLE) {
          state.pmiDMRequestedStatus = PENDING
        }
      })
      .addCase(sendPmiRemovalDMRequest.fulfilled, state => {
        if (state.pmiDMRequestedStatus === PENDING) {
          state.pmiDMRequestedStatus = SUCCEEDED
        }
      })
      .addCase(sendPmiRemovalDMRequest.rejected, state => {
        if (state.pmiDMRequestedStatus === PENDING) {
          state.pmiDMRequestedStatus = FAILED
        }
      })
  },
})

//selectors
export const selectPmiDMRequestedStatus = (state: RootState) =>
  state.pmi.pmiDMRequestedStatus

export default pmiSlice.reducer
